import type { ReactNode } from "react";
import { useT } from "@/contexts/I18nContext";

/**
 * What a table shows before anyone has done anything.
 *
 * Always says what to do next. An empty grid with the word "None" tells a
 * teacher that the product is working and gives them nowhere to go.
 */
export function EmptyState({
  titleKey,
  bodyKey,
  action,
}: {
  titleKey: string;
  bodyKey?: string;
  action?: ReactNode;
}) {
  const t = useT();
  return (
    <div className="py-16 text-center">
      {/*
        A heading, not a paragraph. An empty state is the only thing on the
        screen, and somebody navigating by headings should be able to find out
        what they are looking at.
      */}
      <h2 className="font-display text-lg text-ink">{t(titleKey)}</h2>
      {bodyKey ? <p className="mt-2 text-sm text-ink-muted">{t(bodyKey)}</p> : null}
      {action ? <div className="mt-6 flex justify-center">{action}</div> : null}
    </div>
  );
}
